import { Component, OnInit, Output, EventEmitter, Input, OnChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { dateValidator } from '../../validators/date.validator';
import { caseNumberValidator } from '../../validators/case-number.validator';

@Component({
  selector: 'app-client-form',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientFormComponent implements OnInit, OnChanges {
  clientForm: FormGroup;
  @Output() hasValidClient = new EventEmitter<boolean>();
  @Output() data = new EventEmitter();
  @ViewChild('emailTooltip', { static: false }) emailTooltip: MatTooltip;
  @Input('email') email: string;
  states: string[] = [
    'Out of Country', 'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT',
    'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY',
    'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE',
    'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR',
    'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA',
    'WV', 'WI', 'WY'
  ];

  constructor(private _formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.clientForm = this._formBuilder.group({
      caseNumber: ["", [Validators.required, caseNumberValidator]],
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: ['', Validators.required],
      akaName: [''],
      address: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', [Validators.required]],
      zipCode: ['', [Validators.pattern(/^\d+$/)]],
      telephone: ['', [Validators.required]], // Validators.pattern("\((\d{0,3})\)(\d{0,3})\-(\d{0,4})") does not work due to ^ and $ in angular
      email: ['', [Validators.email, Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'), Validators.required]],
      dateOfBirth: [null, [dateValidator, Validators.required]],
      cellPhone: [''], // Validators.pattern("\((\d{0,3})\)(\d{0,3})\-(\d{0,4})") does not work due to ^ and $ in angular
      attorney: [''],
      attorneyPhone: [''], // Validators.pattern("\((\d{0,3})\)(\d{0,3})\-(\d{0,4})") does not work due to ^ and $ in angular
      attorneyEmail: [""],
      childAttorney: [''],
      childAttorneyPhoneEmail: [""]
    })
    // init event
    this.hasValidClient.emit(this.clientForm.valid);
    this.clientForm.statusChanges.subscribe(res => {
      this.hasValidClient.emit(this.clientForm.valid);
    })
    this.clientForm.valueChanges.subscribe(res => {
      //temp fix for IE
      if (res.dateOfBirth != null && res.dateOfBirth.length == 0) {
        res.dateOfBirth = null;
      }
      if (res.state === 'Out of Country') {
        res.state = 'Out of Ctry.'
      }
      this.data.emit(res);
    })
  }

  ngOnChanges() {
    if (this.email != null) {
      this.clientForm.get('email').setValue(this.email);
    }
  }
}
